import { Component } from '@angular/core';

@Component({
  selector: 'irembogov-client-manager-inivite-gov-exec',
  templateUrl: './client-manager-inivite-gov-exec.component.html',
})
export class ClientManagerIniviteGovExecComponent {}
